// extracted by mini-css-extract-plugin
export default {"image":"image__5Crl-","score":"score__AtYg-"};